import { useEffect, useState } from 'react'

export type ViewMode = 'grid' | 'table'

export function useViewMode() {
  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    const savedViewMode = localStorage.getItem('contentViewMode')
    return savedViewMode === 'grid' || savedViewMode === 'table'
      ? (savedViewMode as ViewMode)
      : 'grid'
  })

  useEffect(() => {
    localStorage.setItem('contentViewMode', viewMode)
  }, [viewMode])

  const toggleViewMode = () => {
    setViewMode((prev) => (prev === 'grid' ? 'table' : 'grid'))
  }

  return {
    viewMode,
    toggleViewMode
  }
}
